import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import Table from "examples/Tables/Table";
import IconButton from "@mui/material/IconButton";
import Switch from "@mui/material/Switch";
import ImageCustom from "components/ImageCustom/ImageCustom";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import moment from "moment";
// import DetailSubCategory from "./DetailSubCategory";
import { getImageUrl } from "api/AttachmentAPI";
import { fetchTemplateToggleStatus, fetchTemplateDelete } from "api/templateService";

function DetailCategoryManagerTable({
  data,
  totalElements,
  curPage,
  setCurPage,
  rowsCount,
  setRowsCount,
  refreshDataAfterChange,
}) {
  // const [setSelectedItem] = useState(null);
  //   const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [imageMap, setImageMap] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchImages = async () => {
      const imageFetchTasks = [];

      data.forEach((item) => {
        const imageTypes = [1, 2, 4];
        imageTypes.forEach((type) => {
          const image = item.attachments?.find((att) => att.attachType === type);
          if (image) {
            const fetchTask = getImageUrl(
              `/api/attachments/downloadFile/${image.encryptedId}`
            ).then((url) => ({
              encryptedId: image.encryptedId,
              url,
            }));
            imageFetchTasks.push(fetchTask);
          }
        });
      });

      const results = await Promise.all(imageFetchTasks);

      const newImageMap = {};
      results.forEach((res) => {
        if (typeof res.url === "string") {
          newImageMap[res.encryptedId] = res.url;
        }
      });

      setImageMap(newImageMap);
    };

    if (data.length > 0) fetchImages();
  }, [data]);

  const handleEdit = (item) => {
    navigate("/Category/detail/add", {
      state: {
        selectedCategory: item.category, // hoặc item.categoryId nếu cần
        templateDetail: item, // toàn bộ object template
      },
    });
  };

  // const handleRowClick = (item) => {
  // setSelectedItem(item);
  // setIsDetailOpen(true);
  // };

  const handleToggleStatus = async (item) => {
    try {
      const result = await fetchTemplateToggleStatus(item.templateId);
      if (result.success) {
        Swal.fire({
          icon: "success",
          title: "Cập nhật trạng thái thành công",
          showConfirmButton: false,
          timer: 1500,
        });
        refreshDataAfterChange();
      } else {
        Swal.fire({
          icon: "error",
          title: "Thất bại",
          text: result.data?.message || "Không thể cập nhật trạng thái",
        });
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      Swal.fire("Lỗi hệ thống", "Vui lòng thử lại sau", "error");
    }
  };

  const handleDelete = async (item) => {
    const confirm = await Swal.fire({
      icon: "warning",
      title: "Xác nhận xóa?",
      text: `Bạn có chắc chắn muốn xóa "${item.templateName}" không?`,
      showCancelButton: true,
      confirmButtonText: "Xóa",
      cancelButtonText: "Hủy",
    });

    if (confirm.isConfirmed) {
      try {
        const result = await fetchTemplateDelete(item.templateId);
        if (result.success) {
          Swal.fire({
            icon: "success",
            title: "Xóa thành công",
            showConfirmButton: false,
            timer: 1500,
          });
          refreshDataAfterChange();
        } else {
          Swal.fire({
            icon: "error",
            title: "Thất bại",
            text: result.data?.message || "Không thể xóa sản phẩm",
          });
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Lỗi hệ thống",
          text: "Không thể kết nối đến máy chủ.",
        });
      }
    }
  };

  const columns = [
    { name: "Tên chi tiết", align: "center", alignHeader: "center", sortable: true },
    { name: "Ngày tạo", align: "center", alignHeader: "center", sortable: true },
    { name: "Chức năng", align: "center", alignHeader: "center" },
    { name: "Hình ảnh mặt trước", align: "center", alignHeader: "center" },
    { name: "Hình ảnh mặt sau", align: "center", alignHeader: "center" },
    { name: "Manocanh", align: "center", alignHeader: "center" },
  ];

  const rows = data.map((item) => ({
    "Tên chi tiết": item.templateName || "---",
    "Ngày tạo": moment(item.createTime).format("DD/MM/YYYY"),
    "Chức năng": (
      <SoftBox display="flex" justifyContent="center" gap={1}>
        <Switch
          title={item.status === 1 ? "Kích hoạt" : "Tắt"}
          checked={item.status === 1}
          onClick={(e) => {
            e.stopPropagation();
            handleToggleStatus(item);
          }}
        />
        <IconButton
          sx={{
            color: "red",
          }}
          title="xóa"
          onClick={(e) => {
            e.stopPropagation();
            handleDelete(item);
          }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
        <IconButton
          sx={{
            color: "green",
          }}
          title="Sửa"
          onClick={(e) => {
            e.stopPropagation();
            handleEdit(item);
          }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </SoftBox>
    ),
    "Hình ảnh mặt trước": (() => {
      const frontAtt = item.attachments?.find((att) => att.attachType === 1);
      const url = frontAtt ? imageMap[frontAtt.encryptedId] : null;
      return <ImageCustom url={url} alt={frontAtt?.attachName} />;
    })(),

    "Hình ảnh mặt sau": (() => {
      const backAtt = item.attachments?.find((att) => att.attachType === 2);
      const url = backAtt ? imageMap[backAtt.encryptedId] : null;
      return <ImageCustom url={url} alt={backAtt?.attachName} />;
    })(),

    Manocanh: (() => {
      const manoAtt = item.attachments?.find((att) => att.attachType === 4);
      const url = manoAtt ? imageMap[manoAtt.encryptedId] : null;
      return <ImageCustom url={url} alt={manoAtt?.attachName} />;
    })(),

    onClick: () => {
      // handleRowClick(item);
    },
  }));

  return (
    <SoftBox>
      <Table
        columns={columns}
        rows={rows}
        isPagination={true}
        totalElements={totalElements}
        rowsPerPageOptions={[5, 10, 20, 50]}
        rowsCount={rowsCount}
        setRowsCount={setRowsCount}
        curPage={curPage}
        setCurPage={setCurPage}
        isRowSelectable={true}
        isDisabledSingleRow={() => false}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        onRowClick={(row) => row.onClick?.()}
      />

      {/* <DetailSubCategory
        open={isDetailOpen}
        onClose={() => setIsDetailOpen(false)}
        selectedDetailCategory={selectedItem}
      /> */}
    </SoftBox>
  );
}

DetailCategoryManagerTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  totalElements: PropTypes.number.isRequired,
  curPage: PropTypes.number.isRequired,
  setCurPage: PropTypes.func.isRequired,
  rowsCount: PropTypes.number.isRequired,
  setRowsCount: PropTypes.func.isRequired,
  refreshDataAfterChange: PropTypes.func.isRequired,
};

export default DetailCategoryManagerTable;
